<div class="termin_wrapper" [style.backgroundColor]="bgColor || ''">
  <h3 *ngIf="title">{{ title }}</h3>
  <span *ngIf="labelCalendar" class="label_calender">
    <hdi-icon [iconName]="'calendar-days'" [size]="size.XSMALL"></hdi-icon>
    {{ labelCalendar }}
  </span>

  <hdi-show-more-less [initialVisibleItems]="2" [step]="2">
    <div
      *ngFor="let event of eventItems; let i = index"
      class="termin"
      [ngClass]="{ active: isOpen[i] }"
      [id]="event.id"
    >
      <div class="termin_header" [ngClass]="{ active: isOpen[i] }">
        <div class="header-text">
          <div class="termin_date">
            <div class="termin_date__day">{{ event.day }}</div>
            <div class="termin_date__month">{{ event.month }}</div>
          </div>
          <div
            class="termin_title"
            (click)="toggleOpenClose(i)"
            [id]="event.key"
          >
            <span class="termin_subtitle"> {{ formatDayTime(event) }}</span>
            {{ event.headline }}
          </div>
        </div>
        <hdi-button
          class="termin_btn"
          [label]="headerLabel | capitalize"
          [type]="accordion"
          [isOpen]="isOpen[i]"
          [iconName]="isOpen[i] ? 'pipe' : 'plus'"
          (click)="toggleOpenClose(i); toggleAnimation(i)"
          [@rotateAnimation]="animationStates[i]"
        ></hdi-button>
      </div>

      <div
        class="termin_content"
        [ngClass]="{ active: isOpen[i], gray: !isSectionBg }"
      >
        <div *ngIf="event.content?.length">
          <strong class="text_small">Inhalt:</strong>
          <div *ngFor="let item of event.content">
            <div *ngIf="item.text" [innerHTML]="item.text"></div>
          </div>
        </div>
        <div *ngIf="event.speakers?.length">
          <strong class="text_small">
            {{
              event.speakers.length === 1 ? 'Referent/in:' : 'Referenten/innen:'
            }}
          </strong>
          <p class="referent_name">{{ event.speakers }}</p>
        </div>
        <div *ngIf="event.location">
          <strong class="text_small">Ort:</strong>
          <p>{{ event.location }}</p>
        </div>
        <div *ngIf="event.educationTime">
          <strong class="text_small">Anrechenbare Bildungszeit:</strong>
          <p>{{ event.educationTime }}</p>
        </div>
        <ng-container
          *ngIf="event.link.url && event.link.label"
          class="termin_link"
        >
          <hdi-link
            [type]="LinkType.EXTERNAL"
            [hrefType]="HrefType.EXTERNAL"
            [href]="event.link.url"
            [label]="event.link.label | capitalize"
            [rel]="event.link.follow"
            [title]="event.link.title"
          ></hdi-link>
        </ng-container>
      </div>
    </div>
  </hdi-show-more-less>
</div>
